<template>
  <div>
    完美：{{values}}
    <Spselect v-model="values"></Spselect>

  </div>
</template>

<script>
  import Spselect from "../common/Spselect";
  export default {
    components:{Spselect},
    data(){
      return{
        values:'4909,4910'
      }
    }

  }
</script>



// WEBPACK FOOTER //
// src/components/test/Testcjw.vue